module.exports = __webpack_public_path__ + "media/images/sandbox/calendar_opt-0ec330e7a6d7cabbe95244869e87c6fa.png";